import { TranslationService } from './translation.service';
import { Pipe, PipeTransform } from '@angular/core';
import * as $ from 'jquery';

@Pipe({
    name: 'translate',
    pure: true
})

export class TranslatePipe implements PipeTransform {

    constructor(private translationService: TranslationService) {
    }

    transform(value: any, originalText: string, wordToMark?: any, style?: any): any {
        this.translationService.translate(value, originalText).then(function (result: string) {
            const element = $('[data-translate ="' + value + '"]');
            if (element.length !== 0) {
                const inputElement = element.find('input');
                if (result) {
                    if (wordToMark && style) {
                        var boldWord = `<b style="color: ${style};">${wordToMark}</b>`;
                        const boldedTranslated = result.replace(wordToMark, boldWord);
                        element.html(boldedTranslated);
                    }
                    else {
                        if (inputElement.length < 1) {
                            if (element.attr('type') === 'textarea') {
                                element.attr('placeholder', result);
                            } else if (element.attr('type') === 'search') {
                                element.attr('placeholder', result);
                            } else {
                                element.text(result);
                            }
                        } else {
                            inputElement.attr('placeholder', result);
                        }
                    }

                } else {
                    if (!!element.text() && inputElement.length < 1) {
                        element.text(originalText);
                    } else {
                        inputElement.attr('placeholder', originalText);
                    }
                }
            } else {
                const dateId = value.replace('.', '_');
                const dateElement = $('#' + dateId);
                if (result && !!dateElement && dateElement.text()) {
                    dateElement.text(result);
                }
            }
        });
        return originalText;
    }
}
